export default __webpack_public_path__ + "static/media/curate.c6832192.png";